module.exports = __webpack_public_path__ + "img/1455127076.f163aef7.jpg";